/**
 * assets/js/frontend.js
 * 
 * @author jjarolim
 */

// import { init as initNavigation } from './frontend/navigation.js'
import { init as initWcag } from './frontend/wcag.js'
import { init as initScrollToTop } from './frontend/scrollToTop.js'
import { init as initScrollObserver } from './frontend/scroll-observer.js'
import { init as initCarousels } from './frontend/carousel.js'
import { init as initBreakpointObserver } from './frontend/breakpoint-observer.js'
import { init as initGdprConsentManagerMatomoBridge } from './frontend/gdpr-consent-manager-matomo-bridge.js'
import { init as initCssFadeIn } from './frontend/css-fade-in.js'
import { init as initUnregisterServiceWorker } from './frontend/unregister-serviceworker.js'
import { init as initLightbox } from './frontend/lightbox.js'

console.log(`
%cdrive ME Website 2026
%cAdwerba Marketing Service GmbH
%cFinest Crafted Websites
%chttps://adwerba.at
`, 
'margin-top:.5em;font-size:2em;margin-bottom:.2em;',
'font-weight:bold;',
'',
'margin-bottom:.5em;',
);

/* On Document Ready */

document.addEventListener( 'DOMContentLoaded', () => {

    initUnregisterServiceWorker()

    initScrollObserver()
    initScrollToTop()
    initWcag()
    initCarousels()
    initBreakpointObserver()
    initGdprConsentManagerMatomoBridge()

    initCssFadeIn()
    initLightbox()

} )